export type LogicalOperationValueType =
    | 'EQUAL_TO_ANY'
    | 'NOT_EQUAL_TO_ANY'
    | 'GREATER_THAN'
    | 'LESS_THAN'
    | 'BETWEEN'
    | 'CONTAINS_ANY'
    | 'CONTAINS_ALL'
    | 'DOES_NOT_CONTAIN_ANY'
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'

export const INPUT_TYPE_DATE_FORMAT = 'DD/MM/YYYY'
export const INPUT_TYPE_TIME_FORMAT = 'HH:mm:ss'
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please contact technical support'
export const NO_TIME_LIMIT_LABEL = 'No Time Limit'

export enum ErrorCode {
    EXAM_ARCHIVED = 'EXAM_ARCHIVED_001',
    SKIP_REASONS_CHANGED = 'SKIP_CODE_001',
    REJECTION_REASONS_CHANGED = 'REJECT_CODE_001',
    JOB_OUPUTS_NOT_POSSIBLE = 'JOB_OUTPUTS_NOT_POSSIBLE_001',
    DAILY_LIMIT_EXCEEDED = 'DAILY_LIMIT_BREACHED',
}

export enum HomeTabKeys {
    Tasks = 'tasks',
    Exams = 'exams',
    Timesheet = 'timesheet',
}

export const DISMISSED_BADGE_NOTIFICATION_KEY = 'dismissed-badge-notification'
export const EXPERTS_THOUGHTS_ITEM_ID = 'experts-thoughts'
export const TASK_INSTRUCTIONS_ITEM_ID = 'task-instructions'
export const SUPPLEMENTARY_DETAILS_ITEM_ID = 'review'

export enum NavigationSource {
    SAVED_TASKS = 'savedTasks',
    INTERNAL = 'internal',
}

export const META_PROJECT_ID = '6e58681a-1f99-44d7-bde3-f1fd0f966059' // Production meta project id

export const ACTIVITY_EVENTS = ['keydown', 'click', 'mousemove', 'scroll']
